import React from 'react';
import '../css/index.css';

export function Banner() {

    return(
        <section className="Banner" >

            <div className='UW'>
                <img src="./img/UW_logo.png" alt="Italian Trulli"></img>
                <img className='word' src="./img/UW_word.png" alt="Italian Trulli"></img>
            </div>

        </section>
    )
}